<template>
  <div>
    <EditForm :student="student"/>
  </div>
</template>

<script>
import EditForm from '@/pages/admin/student/EditForm'
import StudentService from '@/services/StudentService'
import GroupService from '@/services/GroupService'

export default {
  components: {EditForm},
  data: () => ({
    student: StudentService.getDefaultItem()
  }),
  created () {
    this.groupService = new GroupService(this.$store)
    this.groupService.getItem(this.$route.query.group, (data) => {
      if (!this.groupService.isEditable(data.item.attestationInfo.status)) {
        this.$router.back()
      }
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/student/Add.vue